(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .factory('LotSearchGridDTO', LotSearchGridDTO);

    LotSearchGridDTO.$inject = ['$resource','DateUtils'];

    function LotSearchGridDTO($resource, DateUtils) {
        var resourceUrl = "api/lotSearchGridDTO/:id";

        return $resource(resourceUrl, {}, {
            'query': {method:'GET',isArray: true},
            'get': {
                method: 'GET',
                transformResponse:function(data) {
                    if(data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
